import { Platform } from 'react-native';
import type { AppAnalyticsContext, AppAnalyticsPlatform } from './appAnalyticsTypes';
import { isElectronRuntime } from '../utils/isElectron';

export function classifyAppAnalyticsPlatform(): AppAnalyticsPlatform {
  if (Platform.OS === 'ios') return 'ios';
  if (Platform.OS === 'android') return 'android';
  if (isElectronRuntime()) return 'electron';
  return 'web';
}

export function buildAppAnalyticsContext(input?: {
  role?: string | null;
  locationType?: string | null;
}): AppAnalyticsContext {
  const locationRaw = String(input?.locationType || '').toLowerCase();
  const location_type =
    locationRaw === 'test' || locationRaw === 'real'
      ? (locationRaw as 'real' | 'test')
      : undefined;
  const role = input?.role ? String(input.role) : undefined;
  return {
    platform: classifyAppAnalyticsPlatform(),
    ...(role ? { role } : {}),
    ...(location_type ? { location_type } : {}),
  };
}
